import React from 'react';
import {
  AdFormat,
  AdPlacement,
  IAdContainerWithVisibilityProps,
} from 'src/components/ads/types';
import * as S from '../styles';

const advertSpacing = { top: '10px', bottom: '10px' };

const ADS_INDEXES = [
  3,
  9,
  15,
  // Ad every 10th price row
  ...Array(15)
    .fill(10)
    .map((v, i) => v + v * i + 15),
];

const getMobileAd = (index: number) => {
  const placementNumber = Math.min(3, index + 1);

  const triggerPointProp = placementNumber > 1 ? { triggerPoint: 100 } : {};

  return (
    <S.AdvertTableRowElement key={`mobile-ad-container-${index}`}>
      <S.AdContainer
        placement={`dubbelpanorama${placementNumber}` as AdPlacement}
        format={`panorama_${placementNumber}` as AdFormat}
        min={0}
        max={860}
        spacing={advertSpacing}
        {...triggerPointProp}
      />
    </S.AdvertTableRowElement>
  );
};

const desktopAds: IAdContainerWithVisibilityProps[] = [
  { placement: 'panorama_extra', format: 'panorama_1_wde' },
  {
    placement: 'panorama_extra_2',
    format: 'panorama_2_wde',
    triggerPoint: 100,
  },
  {
    placement: 'panorama_extra_2',
    format: 'panorama_2_wde',
    triggerPoint: 100,
  },
];

const getDesktopAd = (index: number) => {
  const adProps = desktopAds[Math.min(desktopAds.length - 1, index)];

  return (
    <S.AdvertTableRowElement
      withPosition
      key={`desktop-ad-container-${index}`}
      className="pj-ui-pricelist--advert"
    >
      <S.AdContainer
        min={860}
        max={10000}
        scalable
        scaleBase=".pj-ui-pricelist--advert"
        spacing={advertSpacing}
        {...adProps}
      />
    </S.AdvertTableRowElement>
  );
};

export const insertTableAds = (tableRows: JSX.Element[], adOffset: number) => {
  const adjustedAdsIndexes = ADS_INDEXES.map(index => index + adOffset).filter(
    index => index <= tableRows.length
  );
  if (!adjustedAdsIndexes.length) {
    // special case for short list
    tableRows.splice(tableRows.length, 0, getDesktopAd(0));
    tableRows.splice(tableRows.length, 0, getMobileAd(0));
    return tableRows;
  }
  for (let i = adjustedAdsIndexes.length - 1; i >= 0; i -= 1) {
    const index = adjustedAdsIndexes[i];

    // Only 3 ads in desktop viewport
    if (i <= 2) {
      tableRows.splice(index, 0, getDesktopAd(i));
    }
    tableRows.splice(index, 0, getMobileAd(i));
  }
  return tableRows;
};
